export const p40_base = [
  ['P40 V40 P80 飞控', '电子件'],
  ['P40 V40 P80 水泵盒', '电子件'],
  ['P40 V40 P80 摇摆雷达', '电子件'],
  ['2019/2020款 P40 V40 P80 地形模块', '电子件'],
  ['P40 动力电机', '电子件'],
  ['P40 V40 P80 无刷喷头', '电子件'],
  ['P40 电调', '电子件'],
  ['P40 V40 蠕动泵A', '电子件'],
  ['P40 V40 蠕动泵B', '电子件'],
  ['P40 V40 P80 睿图', '电子件'],
  ['P40 V40 P80 航灯', '电子件'],
  ['P20/P30 19/20款 P40 V40 P80 UPS模块', '电子件'],
  ['21款智能药箱传感器模块（16L）', '电子件'],
  ['P40 飞机-药箱端接触组件', '电子件'],
  ['P40 V40 P80 FPV相机', '电子件'],
  ['P40 V40 P80 向上雷达', '电子件'],
  ['21款智能药箱传感器模块（20L）', '电子件'],
  ['P40 V40 P80 探照灯', '电子件'],
  ['V40 P40 P80 4G片状天线', '电子件'],
  ['P40 航灯&喷头延长线-长', '电子件'],
  ['P40 V40播撒甩盘电机', '电子件'],
  ['P40 中心仓集线板', '电子件'],
  ['P40 RTK天线-L', '电子件'],
  ['P40 RTK天线-R', '电子件'],
  ['P40 飞机端药箱触片组件', '电子件'],
  ['P40 尾灯', '电子件'],
  ['P40 V40播撒下料电机', '电子件'],
  ['P40 电调信号延长线-长', '电子件'],
  ['P40 航灯&喷头延长线-短', '电子件'],
  ['P40 电调信号延长线-短', '电子件'],
  ['P40 蠕动泵-尾插Y型信号线', '电子件'],
  ['P40 WIFI天线-R', '电子件'],
  ['P40 WIFI天线-L', '电子件'],
  ['P40 V40 P80 航灯-机臂连接线', '电子件'],
  ['P40 V40 P80 喷头-机臂连接线', '电子件'],
  ['P40 飞控-中央集线板连接线', '电子件'],
  ['P40睿播播撒检测模块组件', '电子件'],
  ['P40检料装置控制盒组件', '电子件'],
  ['P40下料口对射灯组件', '电子件'],
  ['P40通讯电源线', '电子件'],
]
export const p40_advance: string[][] = []
